import { Component } from '@angular/core';
import { LoadingController, PopoverController, ViewController } from 'ionic-angular';
import { PaymentService } from '../../../services/payment.service';
import { Organization } from '../../../model/organization';
import { OrganizationService } from '../../../services/organization.service';
import { ImageService } from '../../../services/image.service';
import { AlertMessager } from '../../../lib/alertMessager';
import { UserSearchPopover } from '../../../pages/search/user-search';
import { UserService } from '../../../services/user.service';
import { Secretary } from '../../../model/secretary';

@Component({
    selector: 'organization-setup',
    templateUrl: 'organization-setup.html'
})
export class OrganizationSetupPage {
    setupStage: string = 'start';
    stripeLink: string = null;
    organization: Organization;

    logoFile: any;

    popoverActive: boolean;
    loadingData: boolean;
    saving: boolean;

    accounts: any[] = [];

    constructor(private organizationService: OrganizationService, private paymentService: PaymentService, private alertMessager: AlertMessager,
        private loadingControl: LoadingController, private imageService: ImageService, private popoverController: PopoverController, 
        private userService: UserService, private viewController: ViewController) {
        this.organization = new Organization();
    }

    matchPermissions(a: any, b: any) {
        return a == b;
    }

    createOrganization() {
        if (this.saving)
            return;

        this.saving = true;

        let loading = this.loadingControl.create({
            content: 'Creating Organization...',
        });

        this.organization.paymentRequiredOnEntry = this.stripeLink != null;

        this.organizationService.createOrganization(this.organization)
            .then(data => {
                this.organization = data as Organization;
                console.log("received stripe connect link: ", data);
                loading.dismiss();
                loading = this.loadingControl.create({
                    content: 'Assigning accounts...',
                });
                this.userService.addOrgPermsToUsers(this.accounts, this.organization.id)
                    .then(data => {
                        loading.dismiss();
                        this.saving = false;
                        this.alertMessager.showConfirmation("Success", "Successfully added new Organization " + this.organization.name);
                        this.viewController.dismiss();
                    }, error => {
                        loading.dismiss();
                        this.saving = false;
                        this.alertMessager.showError("Stripe Error", error);
                    })
            }, error => {
                loading.dismiss();
                this.saving = false;
                this.alertMessager.showError("Stripe Error", error);
            })
    }

    createStripeLink() {
        if (this.loadingData)
            return;

        this.loadingData = true;

        let loading = this.loadingControl.create({
            content: 'Generating Stripe Setup Link...',
        });

        loading.present();
        this.paymentService.getNewStripeConnectLink()
            .then(data => {
                console.log("received stripe connect link: ", data);
                loading.dismiss();
                this.loadingData = false;
                this.stripeLink = (data as any).url as string;
                this.organization.paymentRequiredOnEntry = true;
                this.organization.defaultSecretary = new Secretary();
                this.organization.defaultSecretary.name = this.organization.name;
                this.organization.defaultSecretary.usePaypal = false;
                this.organization.defaultSecretary.useStripe = true;
                this.organization.defaultSecretary.stripeConnectedAccountId = (data as any).id;
            }, error => {
                loading.dismiss();
                this.loadingData = false;
                this.alertMessager.showError("Stripe Error", error);
            })
    }

    logoFileChangeListener($event): void {
        this.logoFile = $event.target.files[0];
        this.uploadLogoFile();
    }

    uploadLogoFile() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;
        let fileName = this.organization.name + "_logo_" + this.logoFile.name;

        this.imageService.uploadImage(this.logoFile, fileName, false)
            .then(data => {
                this.popoverActive = false;
                this.organization.logoFileName = "https://nextgenrodeomedia.blob.core.windows.net/images/" + fileName;
            }, error => {
                this.popoverActive = false;
                this.alertMessager.showError("Logo Upload Error", error);
            });
    }

    searchNewAccounts() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let popover = this.popoverController.create(UserSearchPopover, {
            searchTitle: "Search Accounts",
            organizations: [ this.organization ]
        }, { cssClass: 'user-search' });

        popover.present();

        popover.onDidDismiss((data) => {
            this.popoverActive = false;

            if (data && data.buddies && data.buddies.length > 0) {
                data.buddies[0].permission = 2;
                this.accounts.push(data.buddies[0]);
            }
        })
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/organization/organization-setup.ts